import { useTranslation } from 'react-i18next';
import { GlassCard } from '@/components/common/GlassCard';
import type { HomeStats } from '@/types/survey.types';

interface HomeKpiStripProps {
  stats: HomeStats;
}

export function HomeKpiStrip({ stats }: HomeKpiStripProps) {
  const { t } = useTranslation();

  return (
    <div className="sv-kpi-strip-4">
      <GlassCard className="kpi-card">
        <div className="kpi-icon" style={{ background: 'rgba(32,177,90,0.12)', color: 'var(--cp-green)' }}>
          <i className="fas fa-check-circle" aria-hidden="true" />
        </div>
        <div className="kpi-body">
          <span className="kpi-value">{stats.totalAnswered}</span>
          <span className="kpi-label">{t('survey.kpi.answered')}</span>
        </div>
      </GlassCard>

      <GlassCard className="kpi-card">
        <div className="kpi-icon" style={{ background: 'rgba(240,133,33,0.12)', color: 'var(--cp-orange)' }}>
          <i className="fas fa-forward" aria-hidden="true" />
        </div>
        <div className="kpi-body">
          <span className="kpi-value">{stats.totalOmitted}</span>
          <span className="kpi-label">{t('survey.kpi.omitted')}</span>
        </div>
      </GlassCard>

      <GlassCard className="kpi-card">
        <div className="kpi-icon" style={{ background: 'rgba(239,83,149,0.12)', color: 'var(--cp-pink)' }}>
          <i className="fas fa-fire" aria-hidden="true" />
        </div>
        <div className="kpi-body">
          <span className="kpi-value">{stats.streak}</span>
          <span className="kpi-label">{t('survey.kpi.streak')}</span>
        </div>
      </GlassCard>

      <GlassCard className="kpi-card">
        <div className="kpi-icon" style={{ background: 'rgba(64,184,233,0.12)', color: 'var(--cp-cyan)' }}>
          <i className="fas fa-chart-pie" aria-hidden="true" />
        </div>
        <div className="kpi-body">
          <span className="kpi-value">{stats.participationRate}%</span>
          <span className="kpi-label">{t('survey.kpi.participation')}</span>
        </div>
      </GlassCard>
    </div>
  );
}
